import React, { useEffect, useState } from "react";
import { Box, Button, Modal, Typography, TextField } from "@mui/material";
import { Container } from "@mui/system";

import {
  useAssignment,
  useSetAssignment,
} from "../../globals/AssignmentContext";
import { createAssignmentAction } from "../../actions/createAssignment";
import { copyAssignmentAction } from "../../actions/copyAssignment";
import { addAssignmentAction } from "../../actions/addAssignment";
import { useUser } from "../../globals/UserContext";
import Assignment from "./Assignment";
import { fetchAssignmentAction } from "../../actions/fetchAssignment";
import { useSetQuestion } from "../../globals/QuestionContext";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 500,
  height: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function AssignmentPickerList(props) {
  const [singleAssignment, setSingleAssignment] = useState({});
  const setQuestion = useSetQuestion();

  const { assignment } = props;

  const { handlePick } = props;
  const { setPage } = props;

  useEffect(() => {
    if (typeof assignment === "string") {
      fetchAssignmentAction(assignment, setSingleAssignment, setQuestion);
    } else {
      setSingleAssignment(assignment);
    }
  }, [assignment]);

  const handleClick = (event) => {
    handlePick(singleAssignment._id);
  };

  if (singleAssignment !== null && typeof singleAssignment !== "undefined") {
    return (
      <Button variant="h6" onClick={handleClick} sx={{}}>
        {singleAssignment.name}
      </Button>
    );
  } else {
    return <></>;
  }
}
